"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TRANSIT_TIMES = void 0;
exports.DEFAULT_TRANSIT_TIMES = {
    "USPS.FIRST.CLASS.MAIL": { deliveryDays: 4, isDefault: true },
    "USPS.EXPRESS.MAIL": { deliveryDays: 3, isDefault: true },
    "USPS.PARCEL.SELECT.NONPRESORT": { deliveryDays: 6, isDefault: true },
    "USPS.FIRST.CLASS.MAIL.INTERNATIONAL": { deliveryDays: 7, isDefault: true },
    "USPS.PRIORITY.MAIL.INTERNATIONAL": { deliveryDays: 7, isDefault: true },
    "USPS.EXPRESS.MAIL.INTERNATIONAL": { deliveryDays: 7, isDefault: true },
    "USPS.PRIORITY": { deliveryDays: 4, isDefault: true },
    "USPS.GROUND.ADVANTAGE": { deliveryDays: 6, isDefault: true },
    "FEDEX.GROUND": { deliveryDays: 5, isDefault: true },
    "FEDEX.HOME.DELIVERY": { deliveryDays: 5, isDefault: true },
    "FEDEX.SMARTPOST.STANDARD": { deliveryDays: 7, isDefault: true },
    "FEDEX.EXPRESS.SAVER.ECONOMY": { deliveryDays: 3, isDefault: true },
    "FEDEX.2DAY.AM.SHIPPING": { deliveryDays: 2, isDefault: true },
    "FEDEX.2DAY.SHIPPING": { deliveryDays: 2, isDefault: true },
    "FEDEX.OVERNIGHT.STANDARD": { deliveryDays: 1, isDefault: true },
    "FEDEX.PRIORITY.OVERNIGHT": { deliveryDays: 1, isDefault: true },
    "FEDEX.INTERNATIONAL.ECONOMY": { deliveryDays: 7, isDefault: true },
    "UPS.GROUND": { deliveryDays: 5, isDefault: true },
    "UPS.3.DAY.SELECT": { deliveryDays: 3, isDefault: true },
    "UPS.2ND.DAY.AIR": { deliveryDays: 2, isDefault: true },
    "UPS.2ND.DAY.AIR.AM": { deliveryDays: 2, isDefault: true },
    "UPS.NEXT.DAY.AIR": { deliveryDays: 1, isDefault: true },
    "UPS.NEXT.DAY.AIR.AM": { deliveryDays: 1, isDefault: true },
    "UPS.NEXT.DAY.AIR.SAVER": { deliveryDays: 1, isDefault: true },
    "UPS.SUREPOST": { deliveryDays: 6, isDefault: true },
    "UPS.SUREPOST.LIGHTWEIGHT": { deliveryDays: 6, isDefault: true },
    "DHL.PACKET.INTERNATIONAL": { deliveryDays: 1, isDefault: true },
    "DHL.PARCEL.INTERNATIONAL.DIRECT": { deliveryDays: 1, isDefault: true },
    "DHL.PARCEL.INTERNATIONAL.STANDARD": { deliveryDays: 1, isDefault: true },
    "PITNEYBOWES.PARCEL.SELECT": { deliveryDays: 7, isDefault: true },
    "PASSPORT.PRIORITY.DDU.DELCON": { deliveryDays: 10, isDefault: true },
    "PASSPORT.PRIORITY.DDP.DELCON": { deliveryDays: 10, isDefault: true },
    "PASSPORT.EXPRESS.DDP": { deliveryDays: 5, isDefault: true },
};
//# sourceMappingURL=DefaultTransitTimes.js.map